export const VideoPlayerTranslations = {
  'eng': {
    noVideoUploaded: 'No video uploaded',
  },
  'hrv': {
    noVideoUploaded: 'Video nije učitan',
  }
};
